const Monogram = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#B84A39" />
    <circle cx="32" cy="32" r="29" fill="none" stroke="#FAF7F2" strokeOpacity="0.35" strokeWidth="1" />
    <text
      x="32"
      y="41"
      textAnchor="middle"
      fontFamily="Georgia, 'Times New Roman', serif"
      fontStyle="italic"
      fontSize="28"
      fill="#FAF7F2"
    >
      IC
    </text>
  </svg>
);

export default Monogram;
